import { getUniqPayload } from "recharts/types/util/payload/getUniqPayload";
import api from "./api";

export interface Transaction {
  id: string;
  user_id: string;
  subtotal: number;
  discount: number;
  grand_total: number;
  paid_at: string;
  status: string;
  voucher_id: string;
  // some responses may include a voucher flag
  voucher?: boolean;
  created_at: string;
  updated_at: string;
  items_count: string;
  transaction_details: Array<DetailTransaction>;
}

export interface DetailTransaction {
  id: number;
  clip_id: number;
  clip_price: number;
  merchant_name: string;
  court_name: string;
  discount: number;
  total: number;
}

export const transactionService = {
  // Fetch users Transactions with optional pagination
  async fetchTransactionsByUserId(page?: number, limit?: number): Promise<any> {
    const params: any = {};
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;

    const response = await api.get(`/transactions/user`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params,
    });
    // expecting { transactions: Transaction[], pagination: { total, page, limit } }
    return response.data;
  },
  async fetchTransactionsByUserIdPending(): Promise<Transaction[]> {
    const response = await api.get<Transaction[]>(
      "/transactions/user/pending",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    return response.data;
  },
  // create transaction
  async createTransaction(data: {
    cart_items: object[];
    voucher_id: number;
  }): Promise<Transaction> {
    const user_id = JSON.parse(localStorage.getItem("user"))?.id;
    const payload = {
      user_id,
      ...data,
    };
    const response = await api.post("/transactions/create", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  },

  //fetch transaction status
  async getPaymentStatus(invoice_id: string) {
    const response = await api.get(`transactions/${invoice_id}/status_payment`);
    return response.data;
  },

  async checkTransactionStatus(transaction_id: number) {
    const response = await api.get(`transactions/${transaction_id}/status`);
    return response.data;
  },

  async updateTransactionStatus(
    transaction_id: string,
    payment_status: string,
  ) {
    const response = await api.post(
      `transactions/${transaction_id}/${payment_status}/status_update`,
    );
    return response.data;
  },
};
